import * as React from 'react';
import {HtmlViewer} from '@sunbit-dev/web-ui-lib'

// ############################ Imported from Old UI ###########################

export enum DocumentError {
  ErrorLoading = 'ErrorLoading',
  NotFound = 'NotFound',
}

export interface IDocumentProps {
  content?: string;
  error?: DocumentError;
  loadDocument: () => void;
}

// tslint:disable-next-line:variable-name
const Document:React.FC<IDocumentProps> = (props: IDocumentProps) => {
  React.useEffect(() => {
    props.loadDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { error, content } = props;


  if (!content && !error) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <div>
        Error
        {error}
      </div>
    );
  }

  return <HtmlViewer content={content} />;
};

export default Document;
